{
  "--color-primary": ["#3390EC", "#8774E1"],
  "--color-primary-opacity": ["#50A2E91E", "#8378DB1E"],
  "--color-primary-opacity-hover": ["#50A2E940", "#8378DB40"],
  "--color-primary-tint": ["#3390ec1a", "#8774e11a"],
  "--color-primary-shade": ["#4a95d6", "#7b71c6"],
  "--color-background": ["#FFFFFF", "#212121"],
  "--color-background-compact-menu": ["#FFFFFFBB", "#212121DD"],
  "--color-web-app-browser": ["#FFFFFFBB", "#0303038F"],
  "--color-background-compact-menu-reactions": ["#FFFFFFEB", "#212121DD"],
  "--color-background-compact-menu-hover": ["#00000011", "#00000066"],
  "--color-background-secondary": ["#F4F4F5", "#0F0F0F"],
  "--color-background-secondary-accent": ["#E4E4E5", "#191919"],
  "--color-background-sidebar": ["#E4E4E5", "#0F0F0F"],
  "--color-background-own": ["#EEFFDE", "#766AC8"],
  "--color-background-own-apple": ["#DCF8C5", "#766AC8"],
  "--color-background-selected": ["#F4F4F5", "#2C2C2C"],
  "--color-background-own-selected": ["#d0ffac", "#6549d4"],
  "--color-chat-hover": ["#F4F4F5", "#2C2C2C"],
  "--color-chat-active": ["#3390EC", "#766AC8"],
  "--color-chat-active-greyed": ["#60a7f0", "#9288d3"],
  "--color-item-hover": ["#F4F4F5", "#2C2C2C"],
  "--color-item-active": ["#EDEDED", "#292929"],
  "--color-text": ["#000000", "#FFFFFF"],
  "--color-text-secondary": ["#707579", "#AAAAAA"],
  "--color-icon-secondary": ["#707579", "#AAAAAA"],
  "--color-text-secondary-apple": ["#8E8E92", "#AAAAAA"],
  "--color-borders": ["#DADCE0", "#303030"],
  "--color-borders-input": ["#DADCE0", "#5B5B5A"],
  "--color-dividers": ["#C8C6CC", "#3B3B3D"],
  "--color-dividers-android": ["#E7E7E7", "#0F0F0F"],
  "--color-links": ["#3390EC", "#8774E1"],
  "--color-gray": ["#C4C9CC", "#717579"],
  "--color-list-icon": ["#ABAFB1", "#A2A2A2"],
  "--color-default-shadow": ["#72727240", "#1010109c"],
  "--color-light-shadow": ["#7272722B", "#00000040"],
  "--color-active": ["#00C73E", "#8774E1"],
  "--color-active-darker": ["#00a734", "#7b71c6"],
  "--color-green": ["#00C73E", "#00C73E"],
  "--color-green-darker": ["#00A734", "#00A734"],
  "--color-success": ["#00C73E", "#00C73E"],
  "--color-text-meta-colored": ["#4DCD5E", "#8378DB"],
  "--color-reply-hover": ["#F4F4F4", "#272727"],
  "--color-reply-active": ["#E8E9E9", "#2E2F2F"],
  "--color-reply-own-hover": ["#D9F5CE", "#8775DA"],
  "--color-reply-own-hover-apple": ["#cbefb7", "#8775DA"],
  "--color-reply-own-active": ["#C5ECBE", "#917DEA"],
  "--color-reply-own-active-apple": ["#bae6a8", "#917DEA"],
  "--color-accent-own": ["#45AF54", "#FFFFFF"],
  "--color-message-meta-own": ["#4FAE4EFF", "#FFFFFF88"],
  "--color-own-links": ["#3390EC", "#FFFFFF"],
  "--color-code": ["#4a729a", "#8774E1"],
  "--color-code-own": ["#3c7940", "#FFFFFF"],
  "--color-code-bg": ["#70757914", "#00000080"],
  "--color-code-own-bg": ["#70757914", "#00000050"],
  "--color-composer-button": ["#707579CC", "#AAAAAACC"],
  "--color-message-reaction": ["#ebf3fd", "#2b2a35"],
  "--color-message-reaction-hover": ["#c5def9", "#343147"],
  "--color-message-reaction-own": ["#c6eab2", "#675CAF"],
  "--color-message-reaction-hover-own": ["#b5e0a4", "#5B529B"],
  "--color-message-reaction-chosen-hover": ["#1a82ea", "#7864dd"],
  "--color-message-reaction-chosen-hover-own": ["#3f9d4b", "#f5f5f5"],
  "--color-message-non-contact": ["#cceebf", "#AAAAAA"],
  "--color-voice-transcribe-button": ["#e8f3ff", "#2a2a3c"],
  "--color-voice-transcribe-button-own": ["#cceebf", "#8373d3"],
  "--color-topic-blue": ["#2F7772", "#6ff9f0"],
  "--color-topic-yellow": ["#7F693B", "#ffd67e"],
  "--color-topic-violet": ["#8B5A96", "#cb86db"],
  "--color-topic-green": ["#44774A", "#8eee98"],
  "--color-topic-rose": ["#9B576B", "#ff93b2"],
  "--color-topic-red": ["#EB6858", "#fb6f5f"],
  "--color-topic-grey": ["#6C6C6C", "#999999"],
  "--color-forum-unread-topic-hover": ["#e9e9e9", "#363636"],
  "--color-forum-hover-unread-topic-hover": ["#e2e2e2", "#3f3f3f"],
  "--color-chat-username": ["#3C7EB0", "#E9EEF4"],
  "--color-borders-read-story": ["#C4C9CC", "#737373"],
  "--color-background-menu-separator": ["#0000001a", "#ffffff1a"],
  "--color-hover-overlay": ["#00000006", "#ffffff06"],
  "--color-toast-background": ["#202020CC", "#000000CC"]
}
